// 中文语言包
export default {
  nav: {
    home: '首页',
    allProducts: '所有商品',
    myOrder: '我的订单',
    myEvaluate: '我的评价',
    shoppingCart: '购物车',
    shops: '店铺',
    serviceNumber: '客服电话',
    aboutUs: '关于我们',
    contact: '联系我们'
  },
  common: {
    search: '搜索',
    confirm: '确定',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    price: '价格',
    sales: '销量',
    default: '默认',
    loading: '加载中...',
    noData: '暂时没有数据',
    noProducts: '暂时没有商品～',
    sort: '排序：',
    selectAll: '全选',
    quantity: '数量',
    unitPrice: '单价',
    operate: '操作',
    viewDetails: '查看详情',
    enterContent: '请输入内容',
    getCodeSuccess: '验证码获取成功',
    detail: '详情',
    submitOrder: '提交订单',
    invalidPhoneFormat: '手机号格式错误',
    addShoppingCart: '加入购物车',
    buyNow: '立即购买',
    addSuccess: '添加成功'
  },
  category: {
    allResults: '全部结果',
    sort: '排序：',
    default: '默认',
    price: '价格',
    sales: '销量',
    noProducts: '该分类没有商品～'
  },
  evaluate: {
    myEvaluate: '我的评价',
    additionalEvaluate: '追加评价',
    fillProductEvaluate: '填写商品评价：',
    initialEvaluate: '初次评价',
    additionalEvaluateLabel: '追加评价',
    enterYourComment: '请输入您的评语',
    totalImages: '共',
    imagesUnit: '张，还可以上传',
    moreImagesUnit: '张',
    submitEvaluate: '提交评价',
    evaluateSubmitSuccess: '您的评价已成功提交',
    buyAgain: '再次购买',
    backToHome: '返回首页',
    contentCannotBeEmpty: '内容不能为空',
    additionalEvaluateSuccess: '追评成功',
    myOrders: '我的订单',
    evaluate: '评价',
    satisfaction: '商品满意度评分',
    impression: '商品印象',
    review: '评价晒单',
    inputReview: '请输入您的评语',
    uploadCount: '共',
    pictures: '张，还可以上传',
    morePictures: '张',
    submit: '提交评价',
    cannotEvaluate: '商品无法评价或已评价！',
    successTitle: '您的评价已成功提交'
  },
  user: {
    login: '登录',
    loginSuccess: '登录成功',
    register: '注册',
    logout: '退出登录',
    account: '账号',
    password: '密码',
    myAccount: '我的',
    loginAccount: '登录账号',
    confirmLogout: '确定退出登录吗？',
    couponPackage: '券包',
    shippingAddress: '收货地址',
    membershipGrowth: '会员成长值',
    viewAll: '查看全部',
    loginToViewProducts: '登录后查看商品',
    firstUse: '第一次使用国潮商城？',
    enterPhone: '请输入您的手机号码',
    enterEmail: '请输入您的邮箱地址',
    phoneLogin: '手机号登录',
    emailLogin: '邮箱登录',
    enterCode: '请输入验证码',
    getCode: '获取验证码',
    getCodeShort: '获取验证码',
    rememberMe: '七天内免登录',
    loginNow: '立即登录',
    haveAccount: '已有账户？',
    agreement: '阅读并同意',
    nickname: '昵称',
    gender: '性别',
    male: '男',
    female: '女',
    birthDate: '出生日期',
    selectDate: '选择日期',
    boundPhone: '绑定手机号',
    changePhone: '更换手机号',
    replace: '更换',
    securityTips: '安全服务提示',
    phoneSecurity: '绑定手机可提供安全性',
    onePhone: '一个手机号只能绑定一个账号',
    retrieve: '重新获取',
    serviceAgreement: '服务协议',
    confirmServiceAgreement: '请阅读并同意服务协议'
  },
  order: {
    orderNumber: '订单号',
    product: '宝贝',
    unitPrice: '单价',
    quantity: '数量',
    actualPayment: '实付款',
    recipient: '收货人',
    status: '状态',
    afterSaleOrders: '售后订单',
    operation: '操作',
    allOrders: '所有订单',
    waitPay: '待付款',
    waitShip: '待发货',
    waitReceive: '待收货',
    waitEvaluate: '待评价',
    waitGroup: '待成团',
    amountPaid: '实付款',
    includingShipping: '含运费',
    state: '状态',
    completed: '已完成',
    shopName: '店铺名称',
    orderId: '订单编号',
    specification: '1ml/瓶',
    orderDetails: '订单详情',
    buyAgain: '再次购买',
    returnGoods: '退货',
    refund: '退款',
    evaluate: '评价',
    submitOrder: '提交订单',
    processOrder: '处理订单',
    outbound: '商品出库',
    delivery: '等待收货',
    deliveryInfo: '收货信息',
    deliveryAddress: '收货地址',
    recipientPhone: '收货电话',
    sellerInfo: '卖家信息',
    phoneNumber: '联系电话',
    orderInfo: '订单信息',
    trackingNumber: '物流单号',
    logisticsCompany: '物流公司',
    creationTime: '创建时间',
    notes: '备注',
    productAttr: '宝贝属性',
    closed: '已关闭',
    totalPrice: '商品总价',
    freight: '运费',
    discounts: '平台优惠',
    paymentAmount: '需付款',
    logisticsInfo: '物流信息',
    deliveryMethod: '收货方式',
    express: '快递',
    waybill: '运单号',
    logisticsTracking: '物流跟踪',
    groupInfo: '拼团信息',
    waitForGroup: '付款成功，待成团',
    groupSuccess: '恭喜您拼团成功',
    groupFailed: '未能按时成团，拼团失败',
    personGroup: '人团，离拼团成功还差',
    person: '人',
    refundAfterFail: '拼团失败后，已付金额会原路退回！',
    remainingTime: '剩余时间',
    hour: '时',
    minute: '分',
    second: '秒',
    groupLeader: '团长',
    rejectReason: '拒绝原因',
    applyPlatformIntervention: '申请平台介入',
    confirmCancelPay: '确认取消支付？',
    wechatPay: '请使用微信扫一扫支付￥',
    inviteFriends: '邀请好友',
    scanQRCode: '扫描下方二维码或复制链接分享给好友吧',
    copy: '复制'
  },
  orderDetail: {
    orderNumber: '订单号',
    remainingTime: '剩余时间',
    cancelOrder: '取消订单',
    payment: '付款',
    inviteFriends: '邀请好友',
    openNewGroup: '再开一团',
    revokeApplication: '撤销申请',
    deliveryInfo: '收货信息',
    returnAddress: '退货收货地址',
    returnRecipient: '退货收货人',
    returnPhone: '退货收货电话',
    sellerInfo: '卖家信息',
    shopName: '店铺名称',
    contactPhone: '联系电话',
    orderInfo: '订单信息',
    trackingNumber: '物流单号',
    logisticsCompany: '物流公司',
    creationTime: '创建时间',
    remarks: '备注',
    orderStatus: '订单状态',
    waitingPayment: '待付款',
    waitingShipment: '待发货',
    waitingReceipt: '待收货',
    completed: '已完成',
    closed: '已关闭',
    submitOrder: '提交订单',
    orderProcessing: '订单处理',
    productOutbound: '商品出库',
    waitingDelivery: '等待收货',
    groupBuying: '拼团中',
    groupFailed: '拼团失败',
    shipping: '运输中',
    applyAfterSale: '申请售后',
    enterReturnLogistics: '录入退货物流',
    auditPassed: '审核通过',
    auditFailed: '审核未通过',
    refundFailed: '退款失败',
    paymentSuccessful: '付款成功',
    afterSaleMethod: '售后方式',
    selectAfterSaleMethod: '请选择售后方式',
    goodsStatus: '货物状态',
    selectGoodsStatus: '请选择货物状态',
    afterSaleReason: '售后理由',
    selectAfterSaleReason: '请选择售后理由',
    reasonDescription: '原因描述',
    enterReturnReason: '输入申请退货原因描述',
    afterSaleInfo: '售后信息',
    refundOnly: '仅退款',
    returnAndRefund: '退货退款',
    notReceived: '未收到货',
    received: '已收到货',
    returnReasonDescription: '退货理由描述',
    evidence: '凭证',
    returnLogistics: '退货物流',
    logisticsCompanySelect: '请选择物流公司（可输入内容进行搜索）',
    enterTrackingNumber: '请输入物流单号',
    confirmSubmit: '确认提交',
    totalPrice: '商品总价',
    shippingFee: '运费',
    platformDiscount: '平台优惠',
    merchantDiscount: '商户优惠',
    amountToPay: '需付款',
    refundAmount: '退款金额'
  },
  cart: {
    allProducts: '全部商品',
    selectAll: '全选',
    productName: '商品名称',
    productAttr: '商品属性',
    subtotal: '小计',
    operation: '操作',
    empty: '购物车还没有商品，赶紧选购吧。',
    settlement: '结算',
    totalNotIncludeFreight: '合计 (不含运费)',
    coupon: '优惠券',
    emptyCart: '您的购物车还没有宝贝哦~',
    pleaseLogin: '登录',
    viewAfterLogin: '登录后查看商品',
    deleteSelected: '删除所选',
    clearInvalid: '清除失效宝贝',
    selectedCount: '已选商品',
    piece: '件',
    total: '合计 (不含运费)',
    checkout: '结算',
    invalidSelection: '请至少选中一件商品',
    outOfStock: '选中的商品中有下架商品',
    deleteSuccess: '删除成功',
    clearSuccess: '清空成功！',
    clearFailure: '清空失败！',
    goToStore: '进店逛逛',
    promotionalActivities: '促销活动',
    bundledPricing: '定价捆绑',
    activityTypes: {
      type1: '满件减价',
      type2: '满件折扣',
      type3: '满件优惠',
      fixedPrice: '固定价格',
      discount: '折扣',
      fullReduction: '满减'
    },
    coupons: {
      platformCoupon: '平台券',
      merchantCoupon: '商家券',
      receiveSuccess: '领取成功！',
      receiveFailure: '领取失败！'
    },
    noItemsInCart: '你的购物车还没有宝贝哦～',
    removeCartItem: '确定要删除此商品吗？',
    confirmDelete: '确定',
    cancelDelete: '取消',
    deleteConfirmation: '删除后购物车将不存在该商品，确定要删除吗？',
  },
  userCenter: {
    userInfoFailed: '获取个人信息失败！',
    deleteSuccess: '删除成功！',
    loginRequired: '用户未登陆',
    orderCancelSuccess: '订单取消成功',
    orderDeleteSuccess: '订单删除成功',
    confirmReceiveSuccess: '确认收货成功',
    regularMember: '普通会员',
    myMessage: '我的消息',
    orderReceived: '订单xxx已收货期待您的评价',
    orderShipped: '您购买的xxx商品商家已发货，点击查看物流详情',
    orderPaid: '您购买的xxx航拍已支付成功，请耐心等待商家发货。',
    orderClosed: '你未在规定时间内完成支付，订单xxx已关闭，点击查看详情。',
    personalInfo: '个人信息',
    myQa: '我的问答',
    myQuestions: '我的问题',
    myAnswers: '我的答案',
    noQuestions: '你还没有提问',
    noAnswers: '你还没回答',
    batchManage: '批量管理',
    afterSaleProcessing: '售后中',
    afterSaleCompleted: '已完成',
    refundAmount: '退款金额',
    applyTime: '申请时间',
    toBeReviewed: '待评价',
    supplementary: '待追评',
    reviewed: '已评价',
    searchReview: '请输入商品名称或订单号',
    fillReview: '填写商品评价',
    satisfaction: '商品满意度评分',
    impression: '商品印象',
    cheapFine: '物美价廉',
    fastDelivery: '物流很快',
    worthBuying: '值得买',
    general: '一般',
    acceptable: '还可以',
    badReview: '差评',
    comment: '评语',
    enterComment: '请输入您的评语',
    uploadImage: '共0张，还可以上传5张',
    submitReview: '提交评价',
    reviewNotEmpty: '评价内容不能为空',
    addAddress: '新增收货地址',
    defaultAddress: '设置为默认地址',
    myFavorite: '我的收藏',
    favoriteProducts: '收藏的商品',
    favoriteShops: '收藏的店铺',
    cancelFavorite: '取消收藏',
    browsingHistory: '浏览足迹',
    myVouchers: '我的卡券',
    notUsed: '未使用',
    used: '已使用',
    invalid: '已失效',
    authentication: '身份验证',
    nextStep: '下一步',
    enterNewNumber: '输入新号码',
    enterNickname: '请输入昵称',
    enterBirthday: '请输入生日',
    modifySuccess: '修改成功！',
    uploadSuccess: '上传成功，请保存修改！',
    submit: '提交'
  },
  product: {
    productZone: 'XXX 专区',
    sold: '已售',
    favorite: '收藏',
    discounts: '优惠',
    defaultSpec: '默认规格',
    inventory: '库存',
    removed: '已下架',
    guessLike: '猜你喜欢',
    productDetail: '宝贝详情',
    productComment: '商品评论',
    productQa: '商品问答',
    items: '件',
    qaTitle: '有什么疑问，问问买过此商品的同学吧～',
    askQuestion: '我要提问',
    question: '问',
    answer: '答',
    noAnswer: '暂无回答',
    showMore: '显示更多答复',
    hideAnswers: '收起回答',
    iWantToAnswer: '我要回答',
    askQuestionTitle: '提问',
    answerTitle: '回答',
    questionTip: '您的问题将推送给已购用户，TA们会帮您解答哦～',
    questionPrefix: '问：',
    enterContent: '请输入内容',
    anonymousQuestion: '匿名提问',
    anonymousAnswer: '匿名回答',
    cancel: '取 消',
    publish: '发 布',
    enterQuestionContent: '请输入问题内容',
    enterAnswerContent: '请输入回答内容',
    questionSuccess: '提问成功',
    answerSuccess: '回答成功',
    evaluation: {
      all: '全部',
      additionalComment: '{追加评论}',
      confirmReceiptAfter: '确认收货后',
      daysAdditional: '天追加',
      noComments: '暂无评论信息~~'
    },
  },
  store: {
    storeHome: '店铺首页',
    info: '店铺信息',
    collect: '收藏',
    service: '微信客服',
    location: '所在地',
    enter: '进入店铺',
    search: '请输入商品名称'
  },
  afterSale: {
    apply: '申请售后',
    process: '订单处理',
    returning: '退货中',
    completed: '完成',
    refundAmount: '退款金额',
    applyTime: '申请时间',
    code: '售后编号',
    reviewing: '审核中',
    refunding: '退款中',
    refundSuccess: '退款成功',
    refundFailed: '退款失败',
    reviewFailed: '审核不通过',
    evaluating: '评审中',
    returnCompleteRefundRejected: '退货完成，拒绝退款',
    reviewPassed: '审核通过',
    details: '售后详情',
    platformIntervention: '申请平台介入',
    noOrders: '你还没有售后订单哦～',
    interventionSuccess: '申请平台介入成功',
    sellerInfo: '卖家信息',
    shopName: '店铺名称',
    contactPhone: '联系电话',
    orderInfo: '订单信息',
    orderNumber: '订单号',
    paymentChannel: '支付渠道',
    transactionId: '交易号',
    creationTime: '创建时间',
    paymentTime: '付款时间',
    transactionTime: '成交时间',
    product: '宝贝',
    productAttributes: '宝贝属性',
    status: '状态',
    quantity: '数量',
    unitPrice: '单价',
    waitingPayment: '待付款',
    waitingShipment: '待发货',
    waitingReceipt: '待收货',
    closed: '已关闭',
    afterSaleNumber: '售后编号',
    afterSaleDetails: '售后详情',
    applyAfterSale: '申请售后',
    afterSaleMethod: '售后方式',
    selectAfterSaleMethod: '请选择售后方式',
    refundOnly: '仅退款',
    returnAndRefund: '退货退款',
    goodsStatus: '货物状态',
    selectGoodsStatus: '请选择货物状态',
    receivedGoods: '已收到货',
    notReceivedGoods: '未收到货',
    afterSaleReason: '售后理由',
    selectAfterSaleReason: '请选择售后理由',
    reasonDescription: '原因描述',
    enterReturnReason: '输入申请退货原因描述',
    uploadProof: '上传凭证',
    maxUpload3Images: '最多上传3张',
    submitApplication: '提交申请',
    revokeApplication: '撤销申请',
    revokeReturn: '撤销退货',
    contactMerchant: '如有问题，请联系商家',
    rejectReason: '拒绝理由',
    revokeApplicationSuccess: '撤销申请成功',
    revokeReturnSuccess: '撤销退货成功',
    afterSaleApplicationSuccess: '售后申请成功',
    selectAfterSaleMethodError: '请选择售后方式',
    selectGoodsStatusError: '请选择货物状态',
    selectAfterSaleReasonError: '请选择售后理由'
  },
  search: {
    productName: '宝贝',
    shop: '店铺',
    placeholder: '请输入搜索商品',
    enterContent: '请收入搜索内容',
    search: {
      allResults: '全部结果',
      sort: '排序',
      default: '默认',
      price: '价格',
      sales: '销量',
      confirm: '确定',
      clear: '清空',
      noProduct: '搜索不到你要找的宝贝呢换个词试试吧～',
      noShop: '搜索不到你要找的店铺呢换个词试试吧～',
      networkError: '哎呀，网络开小差了～',
      location: '所在地'
    },
    product: {
      productZone: 'XXX 专区',
      sold: '已售',
      favorite: '收藏',
      discounts: '优惠',
      defaultSpec: '默认规格',
      inventory: '库存',
      removed: '已下架',
      guessLike: '猜你喜欢',
      productDetail: '宝贝详情',
      productComment: '商品评论',
      productQa: '商品问答'
    },
    cart: {
      allProducts: '全部商品',
      productName: '商品名称',
      productAttributes: '商品属性',
      unitPrice: '单价',
      quantity: '数量',
      subtotal: '小计',
      operation: '操作',
      discontinued: '已下架',
      coupon: '优惠券',
      availableCoupons: '可领取的优惠券:',
      platformCoupon: '平台券',
      merchantCoupon: '商家券',
      delete: '删除',
      clearInvalid: '清除失效的宝贝',
      selectedItems: '已选商品',
      items: '件',
      total: '合计 (不含运费)',
      couponDiscount: '优惠券',
      checkout: '结算',
      emptyCart: '你的购物车还没有宝贝哦～',
      activityName: '活动优惠',
      meet: '满',
      price: '元',
      storeName: '店铺'
    },
    express: {
      shippingInfo: '收货信息',
      returnShippingInfo: '退货收货信息',
      shippingAddress: '收货地址',
      returnShippingAddress: '退货收货地址',
      recipient: '收货人',
      returnRecipient: '退货收货人',
      phone: '收货电话',
      returnPhone: '退货收货电话',
      sellerInfo: '卖家信息',
      storeName: '店铺名称',
      contactPhone: '联系电话'
    },
    coupon: {
      platformCoupon: '平台券',
      shopCoupon: '店铺券',
      usageCondition: '使用条件：满',
      validPeriod: '有效期：',
      limitedToShop: '限店铺使用',
    }
  },
  placeOrder: {
    selectShippingAddress: '请选择收货地址',
    addNewAddress: '新增地址',
    noShippingInfo: '暂无收货信息',
    recipientInfo: '收货人信息：',
    changeAddress: '更换地址',
    shop: '店铺：',
    product: '宝贝',
    productAttributes: '宝贝属性',
    unitPrice: '单价',
    quantity: '数量',
    discountMethod: '优惠方式',
    subtotal: '小计',
    groupBuy: '拼团',
    flashSale: '秒杀',
    discount: '折扣',
    fixedPriceBundle: '定价捆绑',
    combinationBundle: '组合捆绑',
    sceneMarketing: '场景营销',
    memberPrice: '会员价',
    none: '无',
    addressNotSupported: '当前地址不支持配送，可更换其他地址试试',
    remarksPlaceholder: '如有其他要求，请备注。',
    shipping: '运费：',
    shopTotal: '店铺合计：',
    selectPaymentMethod: '请选择支付方式',
    wechatPay: '微信支付',
    alipay: '支付宝',
    totalPrice: '合计：',
    couponDiscount: '优惠：',
    amountPayable: '应付：',
    pleaseSelectPaymentMethod: '请选择支付方式',
    pleaseSelectShippingAddress: '请选择您的收货地址',
    addressNotSupportedTip: '当前地址不支持配送，请参与红色字提示！',
    paymentSuccess: '支付成功！',
    paymentFailed: '支付失败！',
    paymentCancelled: '支付取消！',
    modifyShippingAddress: '修改收货地址',
    addShippingAddress: '新增收货地址',
    couponDiscountExceedsTotal: '优惠券优惠金额不能大于等于合计金额！',
    cannotCombineWithMerchantCoupon: '不可与商家券叠加使用！',
    couponConditionsNotMet: '不满足优惠券使用条件！',
    cannotUseExceedingCoupon: '不可使用大于等于合计金额的优惠劵！',
    confirmOrderInfo: '请确认订单信息',
    wechatPayment: '微信支付',
  },
  addAddress: {
    region: '所在地区：',
    detailedAddress: '详细地址：',
    recipientName: '收货人姓名：',
    phoneNumber: '手机号码：',
    setAsDefault: '设置为默认收货地址',
    cancel: '取 消',
    confirm: '确 定',
    enterAddress: '请输入地址',
    selectRegion: '请选择地区!',
    enterDetailedAddress: '请填写详细地址!',
    enterRecipientName: '请填写收件人姓名!',
    enterPhoneNumber: '请填写手机号码!',
  },
  couponBox: {
    usageCondition: '使用条件：',
    validPeriod: '有效期至：',
    platformCoupon: '平台券',
    shopCoupon: '店铺券',
    use: '立即使用',
    discount: '优惠：',
    minSpend: '满',
    yuan: '元',
    discountPercent: '折'
  }
}
export const lang = 'zh'



// WEBPACK FOOTER //
// ./src/config/lang/zh.js